<template>
  <div class="ns-product-detail-carousel__container">
    <NsCarousel
      class="ns-product-detail-carousel__carousel"
      :position="phabletAndDown ? slideIndex : null"
      :spacing="phabletAndDown ? 0 : 10"
      :min="phabletAndDown ? 1 : 4"
      :max="phabletAndDown ? 1 : 6"
      :vertical="desktopAndUp"
      @position-changed="handlePositionChanged"
    >
      <div
        v-for="(item, index) in imageSet"
        :key="item.id"
        class="ns-product-detail-carousel__item"
        :class="{
          'ns-product-detail-carousel__item--active': slideIndex === index
        }"
        @click="$emit('slide-select', index)"
      >
        <NsImage
          v-if="item.contentType === 'img'"
          :width="phabletAndDown ? getImageWidth() : '50px'"
          :height="phabletAndDown ? getImageWidth() : '50px'"
          :src="item.src"
          :alt-text="item.alt"
          maintain-ratio="1x1"
          image-fit="contain"
          use-src-set
          itemprop="image"
        />
        <video
          v-if="item.contentType === 'video'"
          :width="phabletAndDown ? getImageWidth() : '50px'"
          :height="phabletAndDown ? getImageWidth() : '50px'"
          :controls="phabletAndDown"
        >
          <source :src="item.src + (phabletAndDown ? '' : '#t=0.5')" />
        </video>
      </div>
    </NsCarousel>
    <div v-if="phabletAndDown" class="ns-product-detail-carousel__dots">
      <button
        v-for="(order, index) in imageSet.length"
        :key="order"
        class="ns-product-detail-carousel__dot"
        :class="{
          'ns-product-detail-carousel__dot--active': index === slideIndex
        }"
        @click="$emit('slide-select', index)"
      >
        <span />
      </button>
    </div>
  </div>
</template>

<script>
import { NsCarousel } from "@nuskin/design-components";
import NsImage from "./NsImage.vue";

/**
 * NsProductDetailCarousel
 *
 * How to use: Slot in images/videos/whatever
 *
 * @event slide-select  When a slide selection occurs, this event emits a
 * function with params: (index)
 */

export default {
  name: "NsProductDetailCarousel",
  components: { NsCarousel, NsImage },
  props: {
    imageSet: {
      type: Array,
      default() {
        return [];
      }
    },
    // showDots: Boolean,
    slideIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    desktopAndUp() {
      return this.$mq === "desktop" || this.$mq === "desktopHD";
    },
    phabletAndDown() {
      return this.$mq === "mobile" || this.$mq === "phablet";
    }
  },
  methods: {
    /**
     * Gets the width an image should be in phablet or mobile
     * Equals the available width minus spacing for left and right arrows
     * Max-width: 290
     */
    getImageWidth() {
      return Math.min(window.innerWidth - 30 - 90, 290) + "px";
    },
    /**
     * On mobile, this will update the current slide index
     */
    handlePositionChanged(index) {
      if (this.phabletAndDown) {
        this.$emit("slide-select", index);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ns-product-detail-carousel__container,
.ns-product-detail-carousel__carousel {
  width: 100%;
}
::v-deep .ns-product-detail-carousel__prev {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
::v-deep .ns-product-detail-carousel__next {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.ns-product-detail-carousel__item {
  max-width: 290px;

  &.ns-product-detail-carousel__item--active:after {
    content: "";
    position: absolute;
    bottom: -6px;
    width: 100%;
    height: 2px;
    background-color: #272525;
  }
}

.ns-product-detail-carousel__dots {
  margin-top: 24px;
  text-align: center;
}

.ns-product-detail-carousel__dot {
  span {
    display: block;
    margin: 12px 4px 0px;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    background: #63666a;
    opacity: 0.5;
  }

  &.ns-product-detail-carousel__dot--active span,
  &:hover span {
    opacity: 1;
  }
}
</style>
